<div class="mon-compte">
    <lib-menu [label]="entite?'<b>'+(entite?.raisonSociale | truncateTexte : 25)+'</b> <br/>'+ (user?.firstName + ' ' + user?.lastName | truncateTexte : 25):''"
        [childre-with-spacement]="true" [noLabelOnMobile]="true" [autoExpandOnMobile]="false" [ngClass]="isGroup ? 'svg-mask-main':'svg-mask-secondary'">
        <ng-template #header>
            <div class="mon-compte-detail">
                <div class="mon-compte-email" [textContent]="user?.firstName + ' ' + user?.lastName"></div>
                <div class="mon-compte-raison-sociale" [textContent]="entite?.raisonSociale"></div>
                <div class="mon-compte-siret">Siret : {{ entite?.siret | siret }}</div>
            </div>
        </ng-template>
        <lib-menu-item menu-label="Mes coordonnées" menu-icon-url="assets/svg/menage_accounts.svg" menu-color="primary"
            [menu-link]="['/mes-coordonnees']" menu-custom-class="menu-svg menu-svg__coordonnees" />
        <lib-menu-item [menu-label]="(isMonoSiret ?  'breadcrumb.my_establishment' : 'breadcrumb.my_establishments') | translate"
            menu-icon-url="assets/svg/entite.svg" menu-color="primary" [menu-link]="isMonoSiret ? ['/mon-etablissement', entite?.siret] : ['/mes-etablissements']"
            menu-custom-class="menu-svg menu-svg__etablissements" />
        <lib-menu-item menu-label="Déconnexion" menu-icon="logout" menu-color="primary" [menu-custom-class]="'menu-item-coordonnees'" (clicked)="onDeconnect()" />
    </lib-menu>
</div>